import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import HeadingLarge from "./HeadingLarge";
import NarrowCol from "./NarrowCol";
import React from "react";
import SustainabilityCounter from "./SustainabilityCounter";

function TakebackStats({ resale, reuse, recycle, landfill }) {
  return (
    <BoxWithGutter
      bg="black"
      pt={[95, null, 160, null]}
      pb={[90, null, 132, null]}
      position="relative"
    >
      <NarrowCol>
        <HeadingLarge
          uppercase
          fontWeight={700}
          color="white"
          textAlign="center"
        >
          The Stats
        </HeadingLarge>
        <Box
          display={["grid", null, "flex", null]}
          gridTemplateColumns="1fr 1fr"
          gridRowGap={38}
          justifyContent="space-between"
          alignItems="center"
          mt={[70, null, 95, null]}
        >
          <SustainabilityCounter
            title="Resale"
            value={`${resale}%`}
            info="Makes the Reskinned resale grade"
            mobFontSize={52}
          />
          <SustainabilityCounter
            title="Reuse"
            value={`${reuse}%`}
            info="Made available for reuse elsewhere"
            mobFontSize={52}
          />
          <SustainabilityCounter
            title="Recycle"
            value={`${recycle}%`}
            info="Recycled responsibly"
            mobFontSize={52}
          />
          <SustainabilityCounter
            title="Landfill"
            value={`${landfill}%`}
            info="That's right, zero landfill"
            mobFontSize={52}
          />
        </Box>
      </NarrowCol>
    </BoxWithGutter>
  );
}

export default TakebackStats;
